import {DeployLatestReleaseActionEditor} from "./DeployLatestReleaseActionEditor";
import {DeployNewReleaseActionEditor} from "./DeployNewReleaseActionEditor";

export {
    DeployLatestReleaseActionEditor,
    DeployNewReleaseActionEditor
};